import { ref } from 'vue'
import Aloha from '@/assets/images/browser/Aloha.svg'
import Bing from '@/assets/images/browser/Bing.svg'
import Brave from '@/assets/images/browser/Brave.svg'
import Chronium from '@/assets/images/browser/Chronium.svg'
import Chrome from '@/assets/images/browser/Chrome.svg'
import DuckDuckGo from '@/assets/images/browser/DuckDuckGo.svg'
import Explorer from '@/assets/images/browser/Explorer.svg'
import Firefox from '@/assets/images/browser/Firefox.svg'
import Maxthron from '@/assets/images/browser/Maxthron.svg'
import Opera from '@/assets/images/browser/Opera.svg'
import OperaGX from '@/assets/images/browser/OperaGX.svg'
import Safari from '@/assets/images/browser/Safari.svg'
import Tor from '@/assets/images/browser/Tor.svg'
import Vivaldi from '@/assets/images/browser/Vivaldi.svg'
import Waterfox from '@/assets/images/browser/Waterfox.svg'
import Yandex from '@/assets/images/browser/Yandex.svg'

export enum BrowserType {
    Aloha = 'Aloha',
    Bing = 'Bing',
    Brave = 'Brave',
    Chrome = 'Chrome',
    Chronium = 'Chronium',
    DuckDuckGo = 'DuckDuckGo',
    Explorer = 'Explorer',
    Firefox = 'Firefox',
    Maxthron = 'Maxthron',
    Opera = 'Opera',
    OperaGX = 'OperaGX',
    Safari = 'Safari',
    Tor = 'Tor',
    Vivaldi = 'Vivaldi',
    Waterfox = 'Waterfox',
    Yandex = 'Yandex'
}

export interface BrowserIcon {
    url: string
    alt: string
}

/**
 * Retrieves the icon URL and alt text for a given browser type.
 *
 * @param browser The browser string (e.g., 'Chrome/124.0.0') to determine the icon for.
 * @returns An object containing the icon URL and alt text.
 */
export function useBrowserIcon(browser: string) {
    const icon = ref<BrowserIcon>({ url: '', alt: '' })
    const browserType = browser.split('/')[0]

    if (browserType)
        switch (browserType) {
            case BrowserType.Aloha:
                icon.value = { url: Aloha, alt: 'Aloha Icon' }
                break
            case BrowserType.Bing:
                icon.value = { url: Bing, alt: 'Bing Icon' }
                break
            case BrowserType.Brave:
                icon.value = { url: Brave, alt: 'Brave Icon' }
                break
            case BrowserType.Chronium:
                icon.value = { url: Chronium, alt: 'Chronium Icon' }
                break
            case BrowserType.Chrome:
                icon.value = { url: Chrome, alt: 'Chrome Icon' }
                break
            case BrowserType.DuckDuckGo:
                icon.value = { url: DuckDuckGo, alt: 'DuckDuckGo Icon' }
                break
            case BrowserType.Explorer:
                icon.value = { url: Explorer, alt: 'Explorer Icon' }
                break
            case BrowserType.Firefox:
                icon.value = { url: Firefox, alt: 'Firefox Icon' }
                break
            case BrowserType.Maxthron:
                icon.value = { url: Maxthron, alt: 'Maxthron Icon' }
                break
            case BrowserType.Opera:
                icon.value = { url: Opera, alt: 'Opera Icon' }
                break
            case BrowserType.OperaGX:
                icon.value = { url: OperaGX, alt: 'OperaGX Icon' }
                break
            case BrowserType.Safari:
                icon.value = { url: Safari, alt: 'Safari Icon' }
                break
            case BrowserType.Tor:
                icon.value = { url: Tor, alt: 'Tor Icon' }
                break
            case BrowserType.Vivaldi:
                icon.value = { url: Vivaldi, alt: 'Vivaldi Icon' }
                break
            case BrowserType.Waterfox:
                icon.value = { url: Waterfox, alt: 'Waterfox Icon' }
                break
            case BrowserType.Yandex:
                icon.value = { url: Yandex, alt: 'Yandex Icon' }
                break
            default:
                break
        }

    return icon.value
}
